<template lang="pug">
div
  div.fullwidth
      div.title-container
          h1.product-title {{ title }}
      template(v-if="title !== 'Documents PDM-80'")
        h2.product-subtitle Documents
        div.margin-bottom
            .manual-download
                .factsandbluebox
                    .bluebox(v-for="(manual, index) in manuals" :key="index")
                        .manual-info
                            Downloadlink(:text="manual.text", :link="manual.link")
                            div(v-if="manual.releaseDate")#info Release Date: {{ manual.date }}
                            div(v-if="manual.softwareVersions")#info Software-Versions {{ manual.softwareVersions }}

      div(v-if="title === 'Documents PDM-600' || title === 'Documents PDM-600-Mobile'")
        h2.product-subtitle Firmware-Download
        div.margin-bottom
            .manual-download
                .factsandbluebox
                    .bluebox
                        .manual-info
                          Downloadlink(
                            text="PDM-600 Firmware Update v1.4.0",
                            link="/download/pdm600/PDM-600_v1.4.0_rev004.zip",
                            download="PDM-600_v1.4.0_rev004.zip"
                          )
                        .checksums Checksums:
                          .checksum
                            span
                              Downloadlink(
                                text="MD5_CHECKSUM",
                                link="/download/pdm600/PDM-600_v1.4.0_rev004.zip.md5",
                                download="MD5_CHECKSUM",
                                :size="20"
                              )
                          .checksum
                            span
                              Downloadlink(
                                text="SHA256_CHECKSUM",
                                link="/download/pdm600/PDM-600_v1.4.0_rev004.zip.sha256",
                                download="SHA256_CHECKSUM",
                                :size="20"
                              )                            
                          .checksum
                            span
                              Downloadlink(
                                text="SHA512_CHECKSUM",
                                link="/download/pdm600/PDM-600_v1.4.0_rev004.zip.sha512",
                                download="SHA512_CHECKSUM",
                                :size="20"
                              )                          

        h3.product-subtitle
          | Important: All versions prior to v1.2.1 require a compatibility update. Please contact support at: 
          Maillink(to='support@bss-hs.de', text='support@bss-hs.de', :showIcon="false", :inline="true")

      div(v-if="title === 'Documents PDM-80'")
        h2.product-subtitle Firmware-Download
        div.margin-bottom
            .manual-download
                .factsandbluebox
                    .bluebox
                        .manual-info
                          Downloadlink(
                            text="PDM-80 Firmware Update v1.4.0",
                            link="/download/pdm80/PDM-80_v1.4.0_rev003.rev004.zip",
                            download="PDM-80_v1.4.0_rev003.rev004.zip"
                          )
                        .checksums Checksums:
                          .checksum
                            span
                              Downloadlink(
                                text="MD5_CHECKSUM",
                                link="/download/pdm80/PDM-80_v1.4.0_rev003.rev004.zip.md5",
                                download="MD5_CHECKSUM",
                                :size="20"
                              )
                          .checksum
                            span
                              Downloadlink(
                                text="SHA256_CHECKSUM",
                                link="/download/pdm80/PDM-80_v1.4.0_rev003.rev004.zip.sha256",
                                download="SHA256_CHECKSUM",
                                :size="20"
                              )                            
                          .checksum
                            span
                              Downloadlink(
                                text="SHA512_CHECKSUM",
                                link="/download/pdm80/PDM-80_v1.4.0_rev003.rev004.zip.sha512",
                                download="SHA512_CHECKSUM",
                                :size="20"
                              )  

        h3.product-subtitle
          | Important: All versions prior to v1.2.1 require a compatibility update. Please contact support at: 
          Maillink(to='support@bss-hs.de', text='support@bss-hs.de', :showIcon="false", :inline="true")

      div(v-if="archiveFiles.length > 0")
        h2.product-subtitle Archive
        div.margin-bottom
            .manual-download
                .factsandbluebox
                    .bluebox(v-for="(manual, index) in archiveFiles" :key="index")
                        .manual-info
                            Downloadlink(:text="manual.text", :link="manual.link")
                            div(v-if="manual.releaseDate")#info Release Date: {{ manual.date }}
                            div(v-if="manual.softwareVersions")#info Software-Versions {{ manual.softwareVersions }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    manuals: {
      type: Array,
      required: true
    },
    archiveFiles: {
      type: Array,
      required: false
    },
  },
  metaInfo: {
    meta: [
      { name: 'robots', content: 'noindex, nofollow' }
    ]
  },
}
</script>

<style lang='sass' scoped>

.factsandbluebox > .bluebox
    border-radius: 0

.factsandbluebox > .bluebox:first-of-type
    border-top-left-radius: 4px
    border-top-right-radius: 4px

.factsandbluebox > .bluebox:last-of-type
    border-bottom-left-radius: 4px
    border-bottom-right-radius: 4px

.manual-info
    display: flex
    #info
        height: 100%
        margin: auto
        padding-bottom: 10px
        flex: 0.5
        font-weight: 300
        font-size: small
        text-align: end

h2.product-subtitle
    font-size: 1.5em
    font-weight: 300
    color: #555
    margin-bottom: 20px
    margin-top: 0

.checksums
    margin-top: 10px
    font-size: small
</style>
